import React from 'react';
import { InputText } from 'primereact/inputtext';

const ProductivityRcp = (props) => {
  const { properties, visibleColumns = [] } = props;
  const styles = {
    specialH: {
      border: 'solid black',
      borderWidth: 'thin',
      width: 'auto',
      padding: '.5rem',
      fontWeight: 'bold',
      color: 'red',
      backgroundColor: '#f8f9fa',
    },
    default: {
      backgroundColor: '#f8f9fa',
      border: 'solid black',
      borderWidth: 'thin',
      width: 'auto',
      padding: '.5rem',
      fontWeight: 'bold',
    },
  };

  const columnDefinitions = {
    workingDays: {
      label: 'working days',
      style: styles.default,
      render: (p) => <InputText value={p.workingDays} onChange={(e) => p.setWorkingDays(e.target.value)} />,
    },
    employees: {
      label: 'employees',
      style: styles.default,
      render: (p) => <InputText value={p.employees} onChange={(e) => p.setEmployyes(e.target.value)} />,
    },
    employees2: {
      label: 'employees2',
      style: styles.default,
      render: (p) => <InputText value={p.employees2} onChange={(e) => p.setEmployyes2(e.target.value)} />,
    },
    intEmployees: {
      label: 'INT employees',
      style: styles.default,
      render: (p) => <InputText value={p.intEmployees} onChange={(e) => p.setIntEmployyes(e.target.value)} />,
    },
    absences: {
      label: 'absences',
      style: styles.default,
      render: (p) => <InputText value={p.absences} onChange={(e) => p.setAbsences(e.target.value)} />,
    },
    sickLeave: {
      label: 'sick leave',
      style: styles.default,
      render: (p) => <InputText value={p.sickLeave} onChange={(e) => p.setSickLeave(e.target.value)} />,
    },
    sickLeaveSpec: {
      label: 'sick leave 7h',
      style: styles.specialH,
      render: (p) => <InputText value={p.sickLeaveSpec} onChange={(e) => p.setSickLeaveSpec(e.target.value)} />,
    },
    specialLeave: {
      label: 'special leave',
      style: styles.default,
      render: (p) => <InputText value={p.specialLeave} onChange={(e) => p.setSpecialLeave(e.target.value)} />,
    },
    specialLeave7h: {
      label: 'special leave 7h',
      style: styles.specialH,
      render: (p) => <InputText value={p.specialLeaveSpec} onChange={(e) => p.setSpecialLeaveSpec(e.target.value)} />,
    },
    childcare: {
      label: 'childcare',
      style: styles.default,
      render: (p) => <InputText value={p.childcare} onChange={(e) => p.setChildcare(e.target.value)} />,
    },
    childcare7h: {
      label: 'childcare 7h',
      style: styles.specialH,
      render: (p) => <InputText value={p.childcareSpec} onChange={(e) => p.setChildcareSpec(e.target.value)} />,
    },
    holidays: {
      label: 'holidays',
      style: styles.default,
      render: (p) => <InputText value={p.holidays} onChange={(e) => p.setHolidays(e.target.value)} />,
    },
    holidays7h: {
      label: 'holidays 7h',
      style: styles.specialH,
      render: (p) => <InputText value={p.holidaysSpec} onChange={(e) => p.setHolidaysSpec(e.target.value)} />,
    },
    managerAbsence: {
      label: 'Manager absence',
      style: styles.default,
      render: (p) => <InputText value={p.managerAbsence} onChange={(e) => p.setManagerAbsence(e.target.value)} />,
    },
  };

  const columnsToDisplay = visibleColumns.map((key) => columnDefinitions[key]).filter(Boolean);

  return (
    <>
      <table style={{ width: '800px' }}>
        <caption
          style={{
            border: 'solid black',
            borderWidth: 'thin',
            width: 'auto',
            padding: '.5rem',
            fontWeight: 'bold',
            backgroundColor: '#f8f9fa',
          }}
        >
          RCP data
        </caption>
        <thead>
          <tr>
            {columnsToDisplay.map((col) => (
              <th key={col.label} style={col.style}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {columnsToDisplay.map((col) => (
              <td key={col.label} style={col.style}>
                {col.render(properties)}
              </td>
            ))}
          </tr>
          <tr>
            {/* Drugi wiersz */}
            {columnsToDisplay.map((col) => {
              if (col.label === 'employees') {
                return (
                  <td key={col.label + '-rate'} style={styles.default}>
                    {properties.emplRate.toString().replace('.', ',')}
                  </td>
                );
              }
              if (col.label === 'employees2') {
                return (
                  <td key={col.label + '-rate'} style={styles.default}>
                    {properties.emplRate2.toString().replace('.', ',')}
                  </td>
                );
              }
              if (col.label === 'INT employees') {
                return (
                  <td key={col.label + '-rate'} style={styles.default}>
                    {properties.intRate.toString().replace('.', ',')}
                  </td>
                );
              }
              return <td key={col.label + '-empty'} style={styles.default}></td>;
            })}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ProductivityRcp;
